export class ConciliacionExportData {

    //  info
    public logo = "logo.img";
    public companyName;
   
    //  details
    public details: Details[];
    public detailsPolizaEgresos: PolizaDetailsEgresos[];
    public detailsPolizaIngresos: PolizaDetailsIngresos[];
    

}

export class Details {
    public CONCILIATION_NUMBER: number;
    public BANK_ACCOUNT_ID: number;
    public CONCILIATION_BALANCE: number;
    public ACCOUNTING_BALANCE: number;
    public EXPENDITURE_IN_TRANSIT: number;
    public DIFFERENCE: number;  
}

export class PolizaDetailsEgresos {
    public CONCEPT: string;
    public CREATION_DATE: any;
    public importe: number;
}
export class PolizaDetailsIngresos {
    public CONCEPT: string;
    public CREATION_DATE: any;
    public importe: number;
}


// WEBPACK FOOTER //
// ./src/app/models/conciliacion-export-data-Cociliacion.ts